(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!window.__ggPcardInit) {
    window.__ggPcardInit = true;

    var GG_WISHLIST_KEY = 'ggems_wishlist';

    function ggGetWishlist(){
      try { return JSON.parse(localStorage.getItem(GG_WISHLIST_KEY)) || []; }
      catch(e){ return []; }
    }
    function ggSaveWishlist(list){
      localStorage.setItem(GG_WISHLIST_KEY, JSON.stringify(list));
    }
    function ggPaintWishlist(){
      var list = ggGetWishlist();
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn){
        var id = btn.getAttribute('data-product-id');
        btn.classList.toggle('is-active', list.indexOf(id) > -1);
      });
    }

    document.addEventListener('click', function(e){
      var wishBtn = e.target.closest('[data-wishlist-toggle]');
      if (wishBtn) {
        e.preventDefault();
        var id = wishBtn.getAttribute('data-product-id');
        var list = ggGetWishlist();
        var idx = list.indexOf(id);
        if (idx > -1) { list.splice(idx, 1); } else { list.push(id); }
        ggSaveWishlist(list);
        ggPaintWishlist();
        return;
      }

      var addBtn = e.target.closest('[data-add-to-cart]');
      if (addBtn) {
        e.preventDefault();
        ggAddToCart(addBtn.getAttribute('data-variant-id'), addBtn, false);
        return;
      }

      var buyBtn = e.target.closest('[data-buy-now]');
      if (buyBtn) {
        e.preventDefault();
        ggAddToCart(buyBtn.getAttribute('data-variant-id'), buyBtn, true);
        return;
      }
    });

    function ggAddToCart(variantId, btn, redirectToCheckout){
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(function(res){
        if (!res.ok) return res.json().then(function(err){ throw err; });
        return res.json();
      })
      .then(function(){
        if (redirectToCheckout) {
          window.location.href = '/checkout';
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
        btn.textContent = 'Added ✓';
        setTimeout(function(){ btn.textContent = originalText; btn.disabled = false; }, 1500);
      })
      .catch(function(err){
        btn.textContent = 'Sold Out';
        setTimeout(function(){ btn.textContent = originalText; btn.disabled = false; }, 1500);
        console.error('GG add to cart error:', err);
      });
    }

    ggPaintWishlist();
  }
  } catch(e) { console.error(e); }
})();

})();
